import { type SoapSet } from '@/features/soap-masters'

// 定型文の絞り込み。**挿入ダイアログ (使う面) と設定ページ (整える面) で同じ意味にする**ため
// ここが唯一の定義にする。片方だけ検索対象が増えると、同じ語で探して結果が違う状態になる。
// (描画を SoapSetLines に寄せたのと同じ理由)

// 作成者 chips の軸。空の作成者は軸にならないので出さない
// (移行元 CSV に作成者列が無い経路があり、そのままだと空の chip が並ぶ)。
export const authorsOf = (soapSets: SoapSet[]): string[] =>
  Array.from(new Set(soapSets.map((s) => s.author_name)))
    .filter(Boolean)
    .sort()

/**
 * 検索語と作成者で絞る。
 *
 * 検索が当たるのは **分類 / 見出し / 作成者 / 全行の本文**。見出しの chips を置かない代わりに
 * 検索が見出しにも当たるようにしてある (= 絞り込み列は 1 本だけ)。
 * `author` を渡さなければ作成者では絞らない (文章マスタ側は作成者の軸を持たない)。
 */
export const filterSoapSets = (
  soapSets: SoapSet[],
  { query, author }: { query: string; author?: string | null }
): SoapSet[] => {
  const q = query.trim().toLowerCase()
  return soapSets.filter((s) => {
    if (author != null && s.author_name !== author) return false
    if (q === '') return true
    return [
      s.condition1,
      s.condition2,
      s.author_name,
      ...s.lines.map((l) => l.content),
    ].some((f) => f.toLowerCase().includes(q))
  })
}
